<template>
  <div id="app">
    <MenuTopo id="menu-topo" />
    <router-view></router-view>
  </div>
</template>

<script>

import MenuTopo from './components/MenuTopo'

export default {
  name: 'App',
  components: {
    MenuTopo
  },
}
</script>

<style>

#menu-topo{
  position: relative;

}

.fade-enter-active, .fade-leave-active {
  /*transition: opacity .5s;*/
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  /*opacity: 0;*/
}
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  }*/
  </style>



// WEBPACK FOOTER //
// src/App.vue